import { ToastMessage } from "./toast-message";
import type { Toast } from "./toast-store";
import { useToastStore } from "./toast-store";

const REGION = "flex w-full flex-col items-center gap-3 sm:items-end";

export const Toasts = () => {
  const { deleteToast, toasts } = useToastStore();

  const renderToasts = (list: Toast[]) => {
    return list.map((toast) => {
      return (
        <ToastMessage
          key={toast.id}
          onClose={() => {
            return void deleteToast(toast.id);
          }}
          toast={toast}
        />
      );
    });
  };

  return (
    <div className="pointer-events-none fixed inset-0 z-50 flex items-end overflow-hidden px-4 py-6 sm:items-start sm:p-6">
      <div className="flex w-full flex-col items-center sm:items-end">
        {/*
          Politeness belongs to the region a toast is inserted into, not to the
          toast, so errors need a region of their own — nested inside a polite one
          they were announced politely. Both stay mounted for the life of the app,
          because a region created in the same render as its content is not
          reliably announced at all.
        */}
        <div aria-live="assertive" className={`${REGION} [&:not(:empty)]:mb-3`}>
          {renderToasts(
            toasts.filter((toast) => {
              return toast.type === "error";
            }),
          )}
        </div>

        <div aria-live="polite" className={REGION}>
          {renderToasts(
            toasts.filter((toast) => {
              return toast.type !== "error";
            }),
          )}
        </div>
      </div>
    </div>
  );
};
